"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPublicKeyObject = exports.StructuredSdk = exports.GenericIdentityContext = exports.BasicIdentityContext = void 0;
const types_1 = require("./utils/types");
const anchor = __importStar(require("@project-serum/anchor"));
const web3_js_1 = require("@solana/web3.js");
const pda_1 = require("./pda");
const spl_token_1 = require("@solana/spl-token");
const helpers_1 = require("./utils/helpers");
const flex_sdk_1 = require("@zetamarkets/flex-sdk");
const serum_1 = require("./utils/serum");
const pda_2 = require("./pda");
const _1 = require(".");
const constants_1 = require("./utils/constants");
const transaction_1 = require("./utils/transaction");
const nodewallet_1 = __importDefault(require("@project-serum/anchor/dist/cjs/nodewallet"));
class BasicIdentityContext {
    constructor(underlyingMint) {
        this.underlyingMint = underlyingMint;
    }
    static from(state) {
        return new BasicIdentityContext(state.underlyingTokenMint);
    }
    getIdentifiers() {
        return [this.underlyingMint.toBuffer()];
    }
    getType() {
        return "structured";
    }
}
exports.BasicIdentityContext = BasicIdentityContext;
class GenericIdentityContext {
    constructor(underlyingMint, quoteMint, identifier) {
        this.underlyingMint = underlyingMint;
        this.quoteMint = quoteMint;
        this.identifier = identifier;
    }
    static from(state) {
        if (!state.identifier) {
            throw new Error("State identifier not available");
        }
        return new GenericIdentityContext(state.underlyingTokenMint, state.quoteTokenMint, state.identifier);
    }
    getIdentifiers() {
        return [
            this.underlyingMint.toBuffer(),
            this.quoteMint.toBuffer(),
            this.identifier.toBuffer(),
        ];
    }
    getType() {
        return "structuredGeneric";
    }
}
exports.GenericIdentityContext = GenericIdentityContext;
const OracleMethod = {
    SpotPrint: { spotPrint: {} },
    ManualPrint: { manualPrint: {} },
};
class StructuredSdk {
    // constructor(
    //   program: anchor.Program<anchor.Idl>,
    //   zetaFlexProgram: anchor.Program<anchor.Idl>,
    //   identityContext: IdentityContext,
    //   state: State,
    //   user: User,
    //   wallet: anchor.Wallet,
    //   network: Network = Network.LOCALNET,
    // ) {
    //   this.program = program as anchor.Program<Structured | StructuredGeneric>;
    //   this.zetaFlexProgram = zetaFlexProgram as anchor.Program<ZetaFlex>;
    //   this.identityContext = identityContext;
    //   this.state = state;
    //   this.user = user;
    //   this.wallet = wallet;
    //   this.network = network;
    //   this.dexPid = findDexPid(network);
    // }
    // Use an identifier: 
    // {
    //   type: "put" | "call", 
    //   symbol: "" 
    // }
    constructor(provider, identifier, wallet, network = flex_sdk_1.Network.LOCALNET, commitment = "confirmed") {
        this.initialized = false;
        this.provider = provider;
        this.program = identifier.createProgram(provider);
        this.zetaFlexProgram = new anchor.Program(_1.zetaFlexIdl, network === flex_sdk_1.Network.LOCALNET ?
            constants_1.ZETA_FLEX_LOCAL_ID
            : constants_1.ZETA_FLEX_ID, provider);
        this.identityContext = identifier.asIdentityContext();
        this.wallet = wallet;
        this.network = network;
        this.commitment = commitment;
        this.dexPid = (0, serum_1.findDexPid)(network);
    }
    async initialize(connection) {
        if (!flex_sdk_1.Flex.isInitialized) {
            await flex_sdk_1.Flex.load(this.zetaFlexProgram.programId, this.network, connection, new nodewallet_1.default(this.wallet.payer));
        }
        if (!this.initialized) {
            const [stateAddress] = await (0, pda_2.findStateAddress)(this.identityContext, this.program.programId);
            this.state = {
                ...(await this.program.account.state.fetch(stateAddress)),
                key: stateAddress
            };
            this.initialized = true;
        }
    }
    connect(user) {
        this.user = new types_1.ExternalUser(user);
    }
    getFlex() {
        return flex_sdk_1.Flex;
    }
    async getUserAccount() {
        return (await (0, pda_1.findUserAccountAddress)(this.user.getPublicKey(), this.state.key, this.program.programId))[0];
    }
    async refreshState() {
        this.state = {
            ...(await this.program.account.state.fetch(this.state.key)),
            key: this.state.key,
        };
    }
    async createUserAccount() {
        const tx = new web3_js_1.Transaction().add(await this.createUserAccountIx());
        return await (0, transaction_1.processTransaction)(this.provider, tx, [], {
            commitment: "confirmed"
        });
    }
    async closeUserAccount() {
        const tx = new web3_js_1.Transaction().add(await this.closeUserAccountIx());
        return await (0, transaction_1.processTransaction)(this.provider, tx, [], {
            commitment: "confirmed"
        });
    }
    async createPricePerSharePage(pageIndex) {
        const tx = new web3_js_1.Transaction().add(await this.createPricePerSharePageIx(pageIndex));
        return await (0, transaction_1.processTransaction)(this.provider, tx, [], {
            commitment: "confirmed"
        });
    }
    async deposit(amount) {
        const [userAccount] = await (0, pda_1.findUserAccountAddress)(this.user.getPublicKey(), this.state.key, this.program.programId);
        const [pricePerSharePage] = await (0, pda_1.findPricePerShareAddress)(this.identityContext, this.state.round.div(new anchor.BN(constants_1.ROUNDS_PER_PAGE)).toNumber(), this.program.programId);
        let signers = [];
        let createTokenAccountIx;
        let initTokenAccountIx;
        let closeTokenAccountIx;
        let createUnderlyingTx;
        let createDerivativeTx;
        let createUserAccountTx;
        let depositIx;
        let userUnderlyingTokenAccount = await this.user.getAssociatedTokenAccount(this.state.underlyingTokenMint);
        if (this.state.underlyingTokenMint.equals(spl_token_1.NATIVE_MINT)) {
            const nativeAccountKeypair = web3_js_1.Keypair.generate();
            const nativePubKey = nativeAccountKeypair.publicKey;
            // Replace in case of native mint
            userUnderlyingTokenAccount = nativePubKey;
            const rent = await this.program.provider.connection.getMinimumBalanceForRentExemption(spl_token_1.AccountLayout.span);
            const lamports = parseInt(new anchor.BN(amount).addn(rent).toString());
            createTokenAccountIx = web3_js_1.SystemProgram.createAccount({
                fromPubkey: this.user.getPublicKey(),
                newAccountPubkey: nativePubKey,
                programId: spl_token_1.TOKEN_PROGRAM_ID,
                space: spl_token_1.AccountLayout.span,
                lamports: lamports,
            });
            initTokenAccountIx = spl_token_1.Token.createInitAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, spl_token_1.NATIVE_MINT, nativePubKey, this.user.getPublicKey());
            closeTokenAccountIx = spl_token_1.Token.createCloseAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, nativePubKey, this.user.getPublicKey(), this.user.getPublicKey(), []);
            signers.push(nativeAccountKeypair);
        }
        else {
            const [, _createUnderlyingTx] = await (0, helpers_1.getOrCreateAssociatedTokenAccount)(this.program.provider, this.state.underlyingTokenMint, this.user.getPublicKey());
            createUnderlyingTx =
                _createUnderlyingTx.length > 0 ? _createUnderlyingTx[0] : undefined;
        }
        const [, _createDerivativeTx] = await (0, helpers_1.getOrCreateAssociatedTokenAccount)(this.program.provider, this.state.derivativeTokenMint, this.user.getPublicKey());
        createDerivativeTx =
            _createDerivativeTx.length > 0 ? _createDerivativeTx[0] : undefined;
        try {
            await this.program.account.userVaultAccount.fetch(userAccount);
        }
        catch (error) {
            // console.log("Error:", error);
            createUserAccountTx = await this.createUserAccountIx();
        }
        let earlyAccessTokenAccount;
        if (!this.state.onlyEarlyAccess ||
            this.state.earlyAccessTokenMint.equals(web3_js_1.PublicKey.default)) {
            earlyAccessTokenAccount = userUnderlyingTokenAccount;
        }
        else {
            const associatedEarlyAccessTokenAccount = await spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, this.state.earlyAccessTokenMint, this.user.getPublicKey());
            const earlyAccessTokenAccountInfo = await this.program.provider.connection.getAccountInfo(this.state.earlyAccessTokenMint);
            if (earlyAccessTokenAccountInfo == null) {
                earlyAccessTokenAccount = userUnderlyingTokenAccount;
            }
            else {
                earlyAccessTokenAccount = associatedEarlyAccessTokenAccount;
            }
        }
        depositIx = this.program.instruction.deposit(new anchor.BN(amount), {
            accounts: {
                state: this.state.key,
                pricePerSharePage,
                userAccount,
                userUnderlyingTokenAccount,
                userEarlyAccessTokenAccount: earlyAccessTokenAccount,
                underlyingTokenVault: this.state.underlyingTokenVault,
                underlyingTokenMint: this.state.underlyingTokenMint,
                userAuthority: this.user.getPublicKey(),
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            },
        });
        let ixs = [
            createTokenAccountIx,
            initTokenAccountIx,
            createUnderlyingTx,
            createDerivativeTx,
            createUserAccountTx,
            depositIx,
            closeTokenAccountIx,
        ].filter((ix) => ix);
        let tx = new web3_js_1.Transaction();
        tx.add(...ixs);
        return await (0, transaction_1.processTransaction)(this.provider, tx, signers, {
            commitment: "confirmed"
        });
    }
    async depositAll() {
        const tx = new web3_js_1.Transaction().add(await this.depositAllIx());
        return await (0, transaction_1.processTransaction)(this.provider, tx, [], {
            commitment: "confirmed"
        });
    }
    async withdrawExpired() {
        // Check if we need to create the underlying token account
        const userUnderlyingTokenAccount = await this.user.getAssociatedTokenAccount(this.state.underlyingTokenMint);
        const ixs = [];
        if ((await this.provider.connection.getAccountInfo(userUnderlyingTokenAccount)) == null) {
            ixs.push(spl_token_1.Token.createAssociatedTokenAccountInstruction(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, this.state.underlyingTokenMint, userUnderlyingTokenAccount, this.user.getPublicKey(), this.user.getPublicKey()));
        }
        const tx = new web3_js_1.Transaction().add(...ixs, await this.withdrawExpiredIx());
        return await (0, transaction_1.processTransaction)(this.provider, tx, [], {
            commitment: "confirmed"
        });
    }
    async instantWithdraw(amount) {
        let signers = [];
        let createTokenAccountIx;
        let initTokenAccountIx;
        let closeTokenAccountIx;
        let instantWithdrawIx;
        let userUnderlyingTokenAccount = await this.user.getAssociatedTokenAccount(this.state.underlyingTokenMint);
        if (this.state.underlyingTokenMint.equals(spl_token_1.NATIVE_MINT)) {
            const nativeAccountKeypair = web3_js_1.Keypair.generate();
            const nativePubKey = nativeAccountKeypair.publicKey;
            // Replace in case of native mint
            userUnderlyingTokenAccount = nativePubKey;
            const rent = await this.program.provider.connection.getMinimumBalanceForRentExemption(spl_token_1.AccountLayout.span);
            createTokenAccountIx = web3_js_1.SystemProgram.createAccount({
                fromPubkey: this.user.getPublicKey(),
                newAccountPubkey: nativePubKey,
                programId: spl_token_1.TOKEN_PROGRAM_ID,
                space: spl_token_1.AccountLayout.span,
                lamports: rent,
            });
            initTokenAccountIx = spl_token_1.Token.createInitAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, spl_token_1.NATIVE_MINT, nativePubKey, this.user.getPublicKey());
            closeTokenAccountIx = spl_token_1.Token.createCloseAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, nativePubKey, this.user.getPublicKey(), this.user.getPublicKey(), []);
            signers.push(nativeAccountKeypair);
        }
        const [userAccount] = await (0, pda_1.findUserAccountAddress)(this.user.getPublicKey(), this.state.key, this.program.programId);
        instantWithdrawIx = this.program.instruction.instantWithdraw(new anchor.BN(amount), {
            accounts: {
                state: this.state.key,
                userAccount: await this.getUserAccount(),
                underlyingTokenMint: this.state.underlyingTokenMint,
                underlyingTokenVault: this.state.underlyingTokenVault,
                userUnderlyingTokenAccount,
                vaultAuthority: this.state.vaultAuthority,
                userAuthority: this.user.getPublicKey(),
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            },
        });
        let ixs = [
            createTokenAccountIx,
            initTokenAccountIx,
            instantWithdrawIx,
            closeTokenAccountIx,
        ].filter((ix) => ix);
        const tx = new web3_js_1.Transaction().add(...ixs);
        return await (0, transaction_1.processTransaction)(this.provider, tx, signers, {
            commitment: "confirmed"
        });
    }
    async initiateWithdraw(amount) {
        const [userAccount] = await (0, pda_1.findUserAccountAddress)(this.user.getPublicKey(), this.state.key, this.program.programId);
        let createUserAccountTx;
        try {
            await this.program.account.userVaultAccount.fetch(userAccount);
        }
        catch (error) {
            // console.log("Error:", error);
            createUserAccountTx = await this.createUserAccountIx();
        }
        let ixs = [createUserAccountTx].filter((ix) => ix);
        ixs = ixs.concat([await this.initiateWithdrawIx(amount)]);
        const tx = new web3_js_1.Transaction().add(...ixs);
        return await (0, transaction_1.processTransaction)(this.provider, tx, [], {
            commitment: "confirmed"
        });
    }
    async completeWithdraw() {
        const [pricePerSharePage] = await (0, pda_1.findPricePerShareAddress)(this.identityContext, 0, this.program.programId);
        // We need to execute as a transaction to handle the unwrapping
        let signers = [];
        const tx = new web3_js_1.Transaction();
        let userUnderlyingTokenAccount = await this.user.getAssociatedTokenAccount(this.state.underlyingTokenMint);
        if (this.state.underlyingTokenMint.equals(spl_token_1.NATIVE_MINT)) {
            const rent = await spl_token_1.Token.getMinBalanceRentForExemptAccount(this.program.provider.connection);
            const nativeKeypair = web3_js_1.Keypair.generate();
            const nativePublicKey = nativeKeypair.publicKey;
            userUnderlyingTokenAccount = nativePublicKey;
            const createWsolIx = web3_js_1.SystemProgram.createAccount({
                fromPubkey: this.user.getPublicKey(),
                newAccountPubkey: nativePublicKey,
                programId: spl_token_1.TOKEN_PROGRAM_ID,
                space: spl_token_1.AccountLayout.span,
                lamports: rent,
            });
            const initWsolIx = spl_token_1.Token.createInitAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, spl_token_1.NATIVE_MINT, nativePublicKey, this.user.getPublicKey());
            signers.push(nativeKeypair);
            tx.add(createWsolIx, initWsolIx);
        }
        else {
            const underlyingAccountInfo = await this.program.provider.connection.getAccountInfo(userUnderlyingTokenAccount);
            if (underlyingAccountInfo === null) {
                const [, createUnderlyingIx] = await (0, helpers_1.getOrCreateAssociatedTokenAccount)(this.program.provider, this.state.underlyingTokenMint, this.user.getPublicKey());
                if (createUnderlyingIx.length > 0) {
                    tx.add(...createUnderlyingIx);
                }
            }
        }
        const [userAccount] = await (0, pda_1.findUserAccountAddress)(this.user.getPublicKey(), this.state.key, this.program.programId);
        tx.add(this.program.instruction.completeWithdraw({
            accounts: {
                state: this.state.key,
                pricePerSharePage,
                userAccount: await this.getUserAccount(),
                underlyingTokenMint: this.state.underlyingTokenMint,
                derivativeTokenMint: this.state.derivativeTokenMint,
                underlyingTokenVault: this.state.underlyingTokenVault,
                derivativeTokenVault: this.state.derivativeTokenVault,
                userUnderlyingTokenAccount,
                vaultAuthority: this.state.vaultAuthority,
                userAuthority: this.user.getPublicKey(),
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            }
        }));
        if (this.state.underlyingTokenMint.equals(spl_token_1.NATIVE_MINT)) {
            const closeWsolIx = spl_token_1.Token.createCloseAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, userUnderlyingTokenAccount, this.user.getPublicKey(), this.user.getPublicKey(), []);
            tx.add(closeWsolIx);
        }
        return await (0, transaction_1.processTransaction)(this.provider, tx, signers, {
            commitment: "confirmed"
        });
    }
    async claimShares() {
        const userPublicKey = this.user.getPublicKey();
        let [, createDerivativeTokenAccountIx] = await (0, helpers_1.getOrCreateAssociatedTokenAccount)(this.program.provider, this.state.derivativeTokenMint, userPublicKey);
        let ixs = createDerivativeTokenAccountIx.concat([await this.claimSharesIx()]);
        const tx = new web3_js_1.Transaction().add(...ixs);
        return await (0, transaction_1.processTransaction)(this.provider, tx, [], {
            commitment: "confirmed"
        });
    }
    async rollToNextOption(admin) {
        const tx = new web3_js_1.Transaction().add(await this.rollToNextOptionIx(admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async mintOptions(admin) {
        const tx = new web3_js_1.Transaction().add(await this.mintOptionsIx(admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async setAdmin(pendingAdmin, admin) {
        const tx = new web3_js_1.Transaction().add(await this.setAdminIx(pendingAdmin, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async pause(admin) {
        const tx = new web3_js_1.Transaction().add(await this.pauseIx(admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async unpause(admin) {
        const tx = new web3_js_1.Transaction().add(await this.unpauseIx(admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async expire(admin) {
        const tx = new web3_js_1.Transaction().add(await this.expireIx(admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async setVaultCap(vaultCap, admin) {
        const tx = new web3_js_1.Transaction().add(await this.setVaultCapIx(vaultCap, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async acceptAdmin(pendingAdmin) {
        const tx = new web3_js_1.Transaction().add(await this.acceptAdminIx(pendingAdmin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, pendingAdmin ? [pendingAdmin] : [], {
            commitment: "confirmed"
        });
    }
    async createOpenOrders(market, admin) {
        const tx = new web3_js_1.Transaction().add(await this.createOpenOrdersIx(market, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async buyUnderlying(market, price, amount, admin) {
        const tx = new web3_js_1.Transaction().add(await this.buyUnderlyingIx(market, price, amount, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async cancelBuyOrder(market, orderId, admin) {
        const tx = new web3_js_1.Transaction().add(await this.cancelBuyOrderIx(market, orderId, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async settle(market, vaultOwner, admin) {
        const tx = new web3_js_1.Transaction().add(await this.settleIx(market, vaultOwner, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async createOtcTerms(sellMint, buyMint, admin) {
        const tx = new web3_js_1.Transaction().add(await this.createOtcTermsIx(sellMint, buyMint, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async closeOtcTerms(sellMint, buyMint, admin) {
        const tx = new web3_js_1.Transaction().add(await this.closeOtcTermsIx(sellMint, buyMint, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async setOtcTerms(sellMint, buyMint, totalPrice, admin) {
        const tx = new web3_js_1.Transaction().add(await this.setOtcTermsIx(sellMint, buyMint, totalPrice, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async cancelOtcTerms(sellMint, buyMint, admin) {
        const tx = new web3_js_1.Transaction().add(await this.cancelOtcTermsIx(sellMint, buyMint, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async fillOtcOrder(sellMint, buyMint) {
        if (!buyMint.equals(this.state.underlyingTokenMint)) {
            throw new Error("Invalid buy mint");
        }
        if (!sellMint.equals(this.state.quoteTokenMint) &&
            !sellMint.equals(this.state.optionTokenMint)) {
            throw new Error("Invalid sell mint");
        }
        const [otcTerms] = await (0, pda_1.findOtcTermsAddress)(this.state.key, sellMint, buyMint, this.program.programId);
        let buyerAcquiringTokenAccount = await spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, sellMint, this.user.getPublicKey());
        const underlyingTokenAccount = await spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, buyMint, this.user.getPublicKey());
        const associatedTokenAccountInfo = await this.program.provider.connection.getAccountInfo(buyerAcquiringTokenAccount);
        let signers = [];
        let createTokenAccountIx;
        let initTokenAccountIx;
        let closeTokenAccountIx;
        let createAssociatedTokenAccountIx;
        let fillOtcOrderIx;
        let buyerUnderlyingTokenAccount = underlyingTokenAccount;
        if (buyMint.equals(spl_token_1.NATIVE_MINT) || sellMint.equals(spl_token_1.NATIVE_MINT)) {
            // We want to wrap the sol from the buyer
            const nativeAccountKeypair = web3_js_1.Keypair.generate();
            const nativePubKey = nativeAccountKeypair.publicKey;
            const rent = await this.program.provider.connection.getMinimumBalanceForRentExemption(spl_token_1.AccountLayout.span);
            // TODO(mainnet)
            const otcTermsData = await this.program.account.otcTerms.fetch(otcTerms);
            let lamports;
            if (buyMint.equals(spl_token_1.NATIVE_MINT)) {
                buyerUnderlyingTokenAccount = nativePubKey;
                lamports = otcTermsData.totalPrice.addn(rent).toNumber();
            }
            else {
                buyerAcquiringTokenAccount = nativePubKey;
                lamports = rent;
            }
            createTokenAccountIx = web3_js_1.SystemProgram.createAccount({
                fromPubkey: this.user.getPublicKey(),
                newAccountPubkey: nativePubKey,
                programId: spl_token_1.TOKEN_PROGRAM_ID,
                space: spl_token_1.AccountLayout.span,
                lamports,
            });
            initTokenAccountIx = spl_token_1.Token.createInitAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, spl_token_1.NATIVE_MINT, nativePubKey, this.user.getPublicKey());
            closeTokenAccountIx = spl_token_1.Token.createCloseAccountInstruction(spl_token_1.TOKEN_PROGRAM_ID, nativePubKey, this.user.getPublicKey(), this.user.getPublicKey(), []);
            signers.push(nativeAccountKeypair);
        }
        if (!sellMint.equals(spl_token_1.NATIVE_MINT) && associatedTokenAccountInfo == null) {
            createAssociatedTokenAccountIx =
                spl_token_1.Token.createAssociatedTokenAccountInstruction(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, sellMint, buyerAcquiringTokenAccount, this.user.getPublicKey(), this.user.getPublicKey());
        }
        let tokenToSellVault;
        if (sellMint.equals(this.state.quoteTokenMint)) {
            tokenToSellVault = this.state.quoteTokenVault;
        }
        else if (sellMint.equals(this.state.optionTokenMint)) {
            tokenToSellVault = this.state.optionTokenVault;
        }
        const accounts = {
            state: this.state.key,
            otcTerms,
            buyerAcquiringTokenAccount: buyerAcquiringTokenAccount,
            buyerPayingTokenAccount: buyerUnderlyingTokenAccount,
            tokenToSellVault,
            tokenToBuyVault: this.state.underlyingTokenVault,
            userAuthority: this.user.getPublicKey(),
            vaultAuthority: this.state.vaultAuthority,
            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        };
        fillOtcOrderIx = this.program.instruction.fillOtcOrder({
            accounts,
        });
        let ixs = [
            createTokenAccountIx,
            initTokenAccountIx,
            createAssociatedTokenAccountIx,
            fillOtcOrderIx,
            closeTokenAccountIx,
        ].filter((ix) => ix);
        let tx = new web3_js_1.Transaction();
        tx.add(...ixs);
        return await (0, transaction_1.processTransaction)(this.provider, tx, signers, {
            commitment: "confirmed"
        });
    }
    async setEarlyAccessMint(earlyAccessMint, admin) {
        const tx = new web3_js_1.Transaction().add(await this.setEarlyAccessMintIx(earlyAccessMint, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async enableEarlyAccessOnly(admin) {
        const tx = new web3_js_1.Transaction().add(await this.enableEarlyAccessOnlyIx(admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async disableEarlyAccessOnly(admin) {
        const tx = new web3_js_1.Transaction().add(await this.disableEarlyAccessOnlyIx(admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async initOptionParameters() {
        const tx = new web3_js_1.Transaction().add(await this.initOptionParametersIx());
        return await (0, transaction_1.processTransaction)(this.provider, tx, [], {
            commitment: "confirmed"
        });
    }
    async createFeeParameters() {
        const tx = new web3_js_1.Transaction().add(await this.createFeeParametersIx());
        return await (0, transaction_1.processTransaction)(this.provider, tx, [], {
            commitment: "confirmed"
        });
    }
    async setManagementFee(fee, admin) {
        const tx = new web3_js_1.Transaction().add(await this.setManagementFeeIx(fee, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async setPerformanceFee(fee, admin) {
        const tx = new web3_js_1.Transaction().add(await this.setPerformanceFeeIx(fee, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async setFeeDestinations(feeDestinations, admin) {
        const tx = new web3_js_1.Transaction().add(await this.setFeeDestinationsIx(feeDestinations, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async setOptionParameters(expiry, strike, admin) {
        const tx = new web3_js_1.Transaction().add(await this.setOptionParametersIx(expiry, strike, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async startAuction(admin) {
        const tx = new web3_js_1.Transaction().add(await this.startAuctionIx(admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async completeAuction(admin) {
        const tx = new web3_js_1.Transaction().add(await this.completeAuctionIx(admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async cancelAuction(admin) {
        const tx = new web3_js_1.Transaction().add(await this.cancelAuctionIx(admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    async setExpireOverride(overridePrice, admin) {
        const tx = new web3_js_1.Transaction().add(await this.setExpireOverrideIx(overridePrice, admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    ;
    async burnOptions(admin) {
        const tx = new web3_js_1.Transaction().add(await this.burnOptionsIx(admin));
        return await (0, transaction_1.processTransaction)(this.provider, tx, admin ? [admin] : [], {
            commitment: "confirmed"
        });
    }
    ;
    async createUserAccountIx() {
        const [userAccount, userBump] = await (0, pda_1.findUserAccountAddress)(this.user.getPublicKey(), this.state.key, this.program.programId);
        return this.program.instruction.createUserAccount(userBump, {
            accounts: {
                userAccount,
                user: this.user.getPublicKey(),
                state: this.state.key,
                payer: this.user.getPublicKey(),
                rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                systemProgram: web3_js_1.SystemProgram.programId,
            },
            signers: this.user.getSigners(),
        });
    }
    async closeUserAccountIx() {
        const [userAccount] = await (0, pda_1.findUserAccountAddress)(this.user.getPublicKey(), this.state.key, this.program.programId);
        return this.program.instruction.closeUserAccount({
            accounts: {
                userAccount,
                state: this.state.key,
                user: this.user.getPublicKey(),
            },
            signers: this.user.getSigners(),
        });
    }
    async createPricePerSharePageIx(pageIndex) {
        const [pricePerSharePage, bump] = await (0, pda_1.findPricePerShareAddress)(this.identityContext, pageIndex, this.program.programId);
        return this.program.instruction.createPricePerSharePage(bump, new anchor.BN(pageIndex), {
            accounts: {
                state: this.state.key,
                pricePerSharePage,
                underlyingTokenMint: this.state.underlyingTokenMint,
                payer: this.wallet.publicKey,
                rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                systemProgram: web3_js_1.SystemProgram.programId,
            },
        });
    }
    async depositIx(amount) {
        const [userAccount] = await (0, pda_1.findUserAccountAddress)(this.user.getPublicKey(), this.state.key, this.program.programId);
        const [pricePerSharePage] = await (0, pda_1.findPricePerShareAddress)(this.identityContext, this.state.round.divn(constants_1.ROUNDS_PER_PAGE).toNumber(), this.program.programId);
        return this.program.instruction.deposit(new anchor.BN(amount), {
            accounts: {
                state: this.state.key,
                pricePerSharePage,
                userAccount,
                userUnderlyingTokenAccount: await this.user.getAssociatedTokenAccount(this.state.underlyingTokenMint),
                // No longer used so pass in a valid token account
                userEarlyAccessTokenAccount: await this.user.getAssociatedTokenAccount(this.state.underlyingTokenMint),
                underlyingTokenVault: this.state.underlyingTokenVault,
                underlyingTokenMint: this.state.underlyingTokenMint,
                userAuthority: this.user.getPublicKey(),
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            },
            signers: this.user.getSigners(),
        });
    }
    async depositAllIx() {
        const [userAccount] = await (0, pda_1.findUserAccountAddress)(this.user.getPublicKey(), this.state.key, this.program.programId);
        const [pricePerSharePage] = await (0, pda_1.findPricePerShareAddress)(this.identityContext, this.state.round.divn(constants_1.ROUNDS_PER_PAGE).toNumber(), this.program.programId);
        return this.program.instruction.depositAll({
            accounts: {
                state: this.state.key,
                pricePerSharePage,
                userAccount,
                userUnderlyingTokenAccount: await this.user.getAssociatedTokenAccount(this.state.underlyingTokenMint),
                // No longer used so pass in a valid token account
                userEarlyAccessTokenAccount: await this.user.getAssociatedTokenAccount(this.state.underlyingTokenMint),
                underlyingTokenVault: this.state.underlyingTokenVault,
                underlyingTokenMint: this.state.underlyingTokenMint,
                userAuthority: this.user.getPublicKey(),
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            },
            signers: this.user.getSigners(),
        });
    }
    async withdrawExpiredIx() {
        const [pricePerSharePage] = await (0, pda_1.findPricePerShareAddress)(this.identityContext, (this.state.round.toNumber() - 1) / constants_1.ROUNDS_PER_PAGE, this.program.programId);
        return this.program.instruction.withdrawExpired({
            accounts: {
                state: this.state.key,
                underlyingTokenMint: this.state.underlyingTokenMint,
                underlyingTokenVault: this.state.underlyingTokenVault,
                userUnderlyingTokenAccount: await this.user.getAssociatedTokenAccount(this.state.underlyingTokenMint),
                derivativeTokenMint: this.state.derivativeTokenMint,
                derivativeTokenVault: this.state.derivativeTokenVault,
                userDerivativeTokenAccount: await this.user.getAssociatedTokenAccount(this.state.derivativeTokenMint),
                pricePerSharePage,
                vaultAuthority: this.state.vaultAuthority,
                userAuthority: this.user.getPublicKey(),
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            }
        });
    }
    async instantWithdrawIx(amount) {
        return this.program.instruction.instantWithdraw(new anchor.BN(amount), {
            accounts: {
                state: this.state.key,
                userAccount: await this.getUserAccount(),
                underlyingTokenMint: this.state.underlyingTokenMint,
                underlyingTokenVault: this.state.underlyingTokenVault,
                userUnderlyingTokenAccount: await this.user.getAssociatedTokenAccount(this.state.underlyingTokenMint),
                vaultAuthority: this.state.vaultAuthority,
                userAuthority: this.user.getPublicKey(),
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            },
            signers: this.user.getSigners(),
        });
    }
    async initiateWithdrawIx(amount) {
        return this.program.instruction.initiateWithdraw(new anchor.BN(amount), {
            accounts: {
                state: this.state.key,
                userAccount: await this.getUserAccount(),
                underlyingTokenMint: this.state.underlyingTokenMint,
                derivativeTokenMint: this.state.derivativeTokenMint,
                derivativeTokenVault: this.state.derivativeTokenVault,
                userDerivativeTokenAccount: await this.user.getAssociatedTokenAccount(this.state.derivativeTokenMint),
                vaultAuthority: this.state.vaultAuthority,
                userAuthority: this.user.getPublicKey(),
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            },
            signers: this.user.getSigners(),
        });
    }
    async completeWithdrawIx() {
        const [pricePerSharePage] = await (0, pda_1.findPricePerShareAddress)(this.identityContext, this.state.round.divn(constants_1.ROUNDS_PER_PAGE).toNumber(), this.program.programId);
        return this.program.instruction.completeWithdraw({
            accounts: {
                state: this.state.key,
                pricePerSharePage,
                userAccount: await this.getUserAccount(),
                underlyingTokenMint: this.state.underlyingTokenMint,
                derivativeTokenMint: this.state.derivativeTokenMint,
                underlyingTokenVault: this.state.underlyingTokenVault,
                derivativeTokenVault: this.state.derivativeTokenVault,
                userUnderlyingTokenAccount: await this.user.getAssociatedTokenAccount(this.state.underlyingTokenMint),
                vaultAuthority: this.state.vaultAuthority,
                userAuthority: this.user.getPublicKey(),
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            },
            signers: this.user.getSigners(),
        });
    }
    async claimSharesIx() {
        const [userAccount] = await (0, pda_1.findUserAccountAddress)(this.user.getPublicKey(), this.state.key, this.program.programId);
        const [pricePerSharePage] = await (0, pda_1.findPricePerShareAddress)(this.identityContext, this.state.round.div(new anchor.BN(constants_1.ROUNDS_PER_PAGE)).toNumber(), this.program.programId);
        return this.program.instruction.claimShares({
            accounts: {
                state: this.state.key,
                pricePerSharePage,
                userAccount,
                underlyingTokenMint: this.state.underlyingTokenMint,
                derivativeTokenMint: this.state.derivativeTokenMint,
                derivativeTokenVault: this.state.derivativeTokenVault,
                userDerivativeTokenAccount: await this.user.getAssociatedTokenAccount(this.state.derivativeTokenMint),
                vaultAuthority: this.state.vaultAuthority,
                userAuthority: this.user.getPublicKey(),
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            },
            signers: this.user.getSigners(),
        });
    }
    async rollToNextOptionIx(admin) {
        await flex_sdk_1.Flex.updateState();
        await this.refreshState();
        const [pricePerSharePage] = await (0, pda_1.findPricePerShareAddress)(this.identityContext, this.state.round.divn(constants_1.ROUNDS_PER_PAGE).toNumber(), this.program.programId);
        // If optionAccount is Pubkey::default use some other accounts instead
        // Otherwsie use correct ones
        let optionAccount;
        let optionTokenMint;
        web3_js_1.PublicKey;
        let optionTokenVault;
        let vault;
        if (this.state.optionAccount.equals(web3_js_1.PublicKey.default)) {
            // Fill in some accounts we know will be initialized
            optionAccount = this.state.underlyingTokenVault;
            optionTokenMint = this.state.underlyingTokenMint;
            optionTokenVault = this.state.underlyingTokenVault;
            vault = flex_sdk_1.Flex.stateAddress;
        }
        else {
            optionAccount = this.state.optionAccount;
            optionTokenMint = this.state.optionTokenMint;
            optionTokenVault = this.state.optionTokenVault;
            [vault] = await flex_sdk_1.flexUtils.getVaultAddress(this.zetaFlexProgram.programId, optionAccount);
        }
        const flexUnderlying = this.identityContext.getType() === "structured" ?
            flex_sdk_1.Flex.getUnderlying(this.state.underlyingTokenMint).address
            : flex_sdk_1.Flex.getUnderlying(this.state.quoteTokenMint).address;
        const accounts = {
            state: this.state.key,
            admin: this.state.admin,
            vaultAuthority: this.state.vaultAuthority,
            underlyingTokenMint: this.state.underlyingTokenMint,
            underlyingTokenVault: this.state.underlyingTokenVault,
            quoteTokenVault: this.state.quoteTokenVault,
            pricePerSharePage,
            derivativeTokenMint: this.state.derivativeTokenMint,
            derivativeTokenVault: this.state.derivativeTokenVault,
            optionAccount,
            optionTokenMint,
            optionTokenVault,
            zetaFlexProgram: this.zetaFlexProgram.programId,
            flexState: flex_sdk_1.Flex.stateAddress,
            flexUnderlying,
            flexVault: vault,
            flexVaultAuthority: flex_sdk_1.Flex.vaultAuthorityAddress,
            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
        };
        return this.program.instruction.rollToNextOption({
            accounts,
            signers: admin ? [admin] : undefined,
        });
    }
    async mintOptionsIx(admin) {
        await flex_sdk_1.Flex.updateState();
        const [optionParameters] = await (0, pda_1.findOptionParameters)(this.identityContext, this.program.programId);
        const flexUnderlyingTokenMint = this.identityContext.getType() === "structured" ?
            this.state.underlyingTokenMint
            : this.state.quoteTokenMint;
        let [underlying] = await flex_sdk_1.flexUtils.getUnderlyingAddress(this.zetaFlexProgram.programId, flexUnderlyingTokenMint);
        let underlyingInfo = flex_sdk_1.Flex.getUnderlying(flexUnderlyingTokenMint);
        let oracleMethod;
        if (underlyingInfo.oracle.equals(web3_js_1.PublicKey.default)) {
            oracleMethod = OracleMethod.ManualPrint;
        }
        else {
            oracleMethod = OracleMethod.SpotPrint;
        }
        // TODO: figure out how to get the count
        let [optionAccount, optionAccountBump] = await flex_sdk_1.flexUtils.getOptionAccountAddress(this.zetaFlexProgram.programId, underlying, new anchor.BN(underlyingInfo.count));
        let [vault, vaultBump] = await flex_sdk_1.flexUtils.getVaultAddress(this.zetaFlexProgram.programId, optionAccount);
        let [optionMint, optionMintBump] = await flex_sdk_1.flexUtils.getOptionMintAddress(this.zetaFlexProgram.programId, optionAccount);
        let [userOptionTokenAccount, userOptionTokenAccountBump] = await flex_sdk_1.flexUtils.getUserOptionMintTokenAccountAddress(this.zetaFlexProgram.programId, optionMint, this.state.vaultAuthority);
        const accounts = {
            state: this.state.key,
            optionParameters,
            admin: this.state.admin,
            underlyingTokenMint: this.state.underlyingTokenMint,
            underlyingTokenVault: this.state.underlyingTokenVault,
            optionAccount,
            optionMint,
            optionTokenVault: userOptionTokenAccount,
            mintAuthority: flex_sdk_1.Flex.mintAuthorityAddress,
            flexState: flex_sdk_1.Flex.stateAddress,
            flexUnderlying: underlying,
            flexVault: vault,
            flexVaultAuthority: flex_sdk_1.Flex.vaultAuthorityAddress,
            vaultAuthority: this.state.vaultAuthority,
            zetaFlexProgram: this.zetaFlexProgram.programId,
            systemProgram: web3_js_1.SystemProgram.programId,
            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            rent: web3_js_1.SYSVAR_RENT_PUBKEY,
        };
        return this.program.instruction.mintOptions(optionAccountBump, optionMintBump, userOptionTokenAccountBump, vaultBump, oracleMethod, {
            accounts,
            signers: admin ? [admin] : undefined,
        });
    }
    async setAdminIx(pendingAdmin, admin) {
        return this.program.instruction.setAdmin(pendingAdmin, {
            accounts: {
                state: this.state.key,
                admin: this.state.admin,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async pauseIx(admin) {
        return this.program.instruction.pause({
            accounts: {
                state: this.state.key,
                admin: this.state.admin
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async unpauseIx(admin) {
        return this.program.instruction.unpause({
            accounts: {
                state: this.state.key,
                admin: this.state.admin
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async expireIx(admin) {
        return this.program.instruction.expire({
            accounts: {
                state: this.state.key,
                admin: this.state.admin
            },
            signers: admin ? [admin] : undefined
        });
    }
    async setVaultCapIx(vaultCap, admin) {
        return this.program.instruction.raiseVaultCap(vaultCap, {
            accounts: {
                state: this.state.key,
                admin: this.state.admin
            },
            signers: admin ? [admin] : undefined
        });
    }
    async acceptAdminIx(pendingAdmin) {
        return this.program.instruction.acceptAdmin({
            accounts: {
                state: this.state.key,
                pendingAdmin: this.state.pendingAdmin,
            },
            signers: pendingAdmin ? [pendingAdmin] : undefined,
        });
    }
    async createOpenOrdersIx(market, admin) {
        const [openOrders, bump] = await (0, pda_1.findOpenOrdersAddress)(market.address, this.program.programId);
        const accounts = {
            state: this.state.key,
            vaultAuthority: this.state.vaultAuthority,
            underlyingTokenMint: this.state.underlyingTokenMint,
            admin: this.state.admin,
            openOrders,
            market: market.address,
            systemProgram: web3_js_1.SystemProgram.programId,
            dexProgram: this.dexPid,
            rent: web3_js_1.SYSVAR_RENT_PUBKEY,
        };
        return this.program.instruction.createOpenOrders(bump, {
            accounts,
            signers: admin ? [admin] : undefined,
        });
    }
    async buyUnderlyingIx(market, price, amount, admin) {
        return this.program.instruction.buyUnderlying(market.priceNumberToLots(price), amount, {
            accounts: {
                admin: this.state.admin,
                state: this.state.key,
                vaultAuthority: this.state.vaultAuthority,
                dexProgram: this.dexPid,
                market: market.address,
                openOrders: this.state.openOrders,
                //@ts-ignore: serum
                requestQueue: market._decoded.requestQueue,
                //@ts-ignore: serum
                eventQueue: market._decoded.eventQueue,
                //@ts-ignore: serum
                bids: market.bidsAddress,
                //@ts-ignore: serum,
                asks: market.asksAddress,
                //@ts-ignore: serum,
                coinVault: market._decoded.baseVault,
                //@ts-ignore: serum,
                pcVault: market._decoded.quoteVault,
                underlyingTokenMint: this.state.underlyingTokenMint,
                quoteTokenVault: this.state.quoteTokenVault,
                rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                systemProgram: web3_js_1.SystemProgram.programId,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async cancelBuyOrderIx(market, orderId, admin) {
        return this.program.instruction.cancelBuyOrder(orderId, {
            accounts: {
                admin: this.state.admin,
                state: this.state.key,
                vaultAuthority: this.state.vaultAuthority,
                market: market.address,
                openOrders: this.state.openOrders,
                //@ts-ignore: serum
                eventQueue: market._decoded.eventQueue,
                //@ts-ignore: serum
                bids: market.bidsAddress,
                //@ts-ignore: serum,
                asks: market.asksAddress,
                underlyingTokenMint: this.state.underlyingTokenMint,
                dexProgram: this.dexPid,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async settleIx(market, vaultOwner, admin) {
        return this.program.instruction.settle({
            accounts: {
                admin: this.state.admin,
                state: this.state.key,
                vaultAuthority: this.state.vaultAuthority,
                underlyingTokenVault: this.state.underlyingTokenVault,
                quoteTokenVault: this.state.quoteTokenVault,
                dexProgram: this.dexPid,
                market: market.address,
                openOrders: this.state.openOrders,
                // @ts-ignore serum
                coinVault: market._decoded.baseVault,
                // @ts-ignore serum
                pcVault: market._decoded.quoteVault,
                underlyingTokenMint: this.state.underlyingTokenMint,
                vaultSigner: vaultOwner,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async createOtcTermsIx(sellMint, buyMint, admin) {
        const [otcTerms, bump] = await (0, pda_1.findOtcTermsAddress)(this.state.key, sellMint, buyMint, this.program.programId);
        return this.program.instruction.createOtcTerms(bump, {
            accounts: {
                state: this.state.key,
                otcTerms,
                tokenMintToSell: sellMint,
                tokenMintToBuy: buyMint,
                admin: this.state.admin,
                systemProgram: web3_js_1.SystemProgram.programId,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async closeOtcTermsIx(sellMint, buyMint, admin) {
        const [otcTerms, bump] = await (0, pda_1.findOtcTermsAddress)(this.state.key, sellMint, buyMint, this.program.programId);
        return this.program.instruction.closeOtcTerms({
            accounts: {
                state: this.state.key,
                otcTerms,
                admin: this.state.admin,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async setOtcTermsIx(sellMint, buyMint, totalPrice, admin) {
        const [otcTerms] = await (0, pda_1.findOtcTermsAddress)(this.state.key, sellMint, buyMint, this.program.programId);
        return this.program.instruction.setOtcTerms(new anchor.BN(totalPrice), {
            accounts: {
                state: this.state.key,
                otcTerms,
                admin: this.state.admin,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async cancelOtcTermsIx(sellMint, buyMint, admin) {
        const [otcTerms] = await (0, pda_1.findOtcTermsAddress)(this.state.key, sellMint, buyMint, this.program.programId);
        return this.program.instruction.cancelOtcTerms({
            accounts: {
                state: this.state.key,
                otcTerms,
                admin: this.state.admin,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async fillOtcOrderIx(sellMint, buyMint) {
        await this.refreshState();
        if (!buyMint.equals(this.state.underlyingTokenMint)) {
            throw new Error("Invalid buy mint");
        }
        const [otcTerms] = await (0, pda_1.findOtcTermsAddress)(this.state.key, sellMint, buyMint, this.program.programId);
        let buyerAcquiringTokenAccount, tokenToSellVault;
        if (sellMint.equals(this.state.quoteTokenMint)) {
            buyerAcquiringTokenAccount = await this.user.getAssociatedTokenAccount(this.state.quoteTokenMint);
            tokenToSellVault = this.state.quoteTokenVault;
        }
        else if (sellMint.equals(this.state.optionTokenMint)) {
            // buyerAcquiringTokenAccount = this.user.optionTokenAccount;
            buyerAcquiringTokenAccount = await spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, this.state.optionTokenMint, this.user.getPublicKey());
            tokenToSellVault = this.state.optionTokenVault;
        }
        else {
            throw new Error("Invalid sell mint");
        }
        return this.program.instruction.fillOtcOrder({
            accounts: {
                state: this.state.key,
                otcTerms,
                buyerAcquiringTokenAccount,
                buyerPayingTokenAccount: await this.user.getAssociatedTokenAccount(this.state.underlyingTokenMint),
                tokenToSellVault,
                tokenToBuyVault: this.state.underlyingTokenVault,
                userAuthority: this.user.getPublicKey(),
                vaultAuthority: this.state.vaultAuthority,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            },
            signers: this.user.getSigners(),
        });
    }
    async setEarlyAccessMintIx(earlyAccessMint, admin) {
        return this.program.instruction.setEarlyAccessMint(earlyAccessMint, {
            accounts: {
                state: this.state.key,
                admin: this.state.admin,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async enableEarlyAccessOnlyIx(admin) {
        return this.program.instruction.enableEarlyAccess({
            accounts: {
                state: this.state.key,
                admin: this.state.admin,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async disableEarlyAccessOnlyIx(admin) {
        return this.program.instruction.disableEarlyAccess({
            accounts: {
                state: this.state.key,
                admin: this.state.admin,
            },
            signers: admin ? [admin] : undefined
        });
    }
    async initOptionParametersIx() {
        const [optionParameters, optionParametersBump] = await (0, pda_1.findOptionParameters)(this.identityContext, this.program.programId);
        return this.program.instruction.initOptionParameters(optionParametersBump, {
            accounts: {
                state: this.state.key,
                optionParameters,
                payer: this.wallet.publicKey,
                systemProgram: web3_js_1.SystemProgram.programId,
            },
            signers: [this.wallet.payer],
        });
    }
    async createFeeParametersIx() {
        const [feeParameters, bump] = await (0, pda_2.findFeeParameters)(this.state.key, this.program.programId);
        // @ts-ignore
        return this.program.instruction.createFeeParameters(bump, {
            accounts: {
                state: this.state.key,
                feeParameters: feeParameters,
                payer: this.wallet.publicKey,
                rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                systemProgram: web3_js_1.SystemProgram.programId,
            }
        });
    }
    async setManagementFeeIx(fee, admin) {
        await this.refreshState();
        // @ts-ignore
        return this.program.instruction.setManagementFee(fee, {
            accounts: {
                state: this.state.key,
                feeParameters: this.state.feeParameters,
                admin: this.state.admin,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async setPerformanceFeeIx(fee, admin) {
        await this.refreshState();
        // @ts-ignore
        return this.program.instruction.setPerformanceFee(fee, {
            accounts: {
                state: this.state.key,
                feeParameters: this.state.feeParameters,
                admin: this.state.admin,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async setFeeDestinationsIx(feeDestinations, admin) {
        if (feeDestinations.length != 2) {
            throw new Error("Must contain exactly two fee destinations");
        }
        // @ts-ignore 
        return this.program.instruction.setFeeDestinations(feeDestinations, {
            accounts: {
                state: this.state.key,
                feeParameters: this.state.feeParameters,
                admin: this.state.admin,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async setOptionParametersIx(expiry, strike, admin) {
        const [optionParameters] = await (0, pda_1.findOptionParameters)(this.identityContext, this.program.programId);
        return this.program.instruction.setNextOption(expiry, strike, {
            accounts: {
                state: this.state.key,
                optionParameters,
                admin: this.state.admin,
                vaultAuthority: this.state.vaultAuthority,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async startAuctionIx(admin) {
        const BID_OFFSET = this.network === flex_sdk_1.Network.LOCALNET
            ? new anchor.BN(15)
            : new anchor.BN(15 * 60);
        const COOLDOWN_OFFSET = this.network === flex_sdk_1.Network.LOCALNET
            ? new anchor.BN(60)
            : new anchor.BN(60 * 60);
        const startTime = new anchor.BN(Math.floor(Date.now() / 1000));
        const bidEndTs = startTime.add(BID_OFFSET);
        const cooldownEndTs = bidEndTs.add(COOLDOWN_OFFSET);
        const optionBalance = await (0, helpers_1.getBalanceFromProvider)(this.program.provider, this.state.optionTokenVault);
        let [auctionAccount, auctionBump] = await flex_sdk_1.flexUtils.getAuctionAddress(this.zetaFlexProgram.programId, this.state.optionTokenMint, this.state.vaultAuthority, optionBalance, bidEndTs, cooldownEndTs);
        let [auctionVault, auctionVaultBump] = await flex_sdk_1.flexUtils.getAuctionVaultAddress(this.zetaFlexProgram.programId, this.state.optionTokenMint, this.state.vaultAuthority, optionBalance, bidEndTs, cooldownEndTs);
        const type = this.identityContext.getType();
        return this.program.instruction.initializeAuction(startTime, auctionBump, auctionVaultBump, {
            accounts: {
                admin: this.state.admin,
                state: this.state.key,
                vaultAuthority: this.state.vaultAuthority,
                bidTokenVault: type === "structured" ?
                    this.state.quoteTokenVault
                    : this.state.underlyingTokenVault,
                optionTokenVault: this.state.optionTokenVault,
                bidTokenMint: type === "structured" ?
                    this.state.quoteTokenMint
                    : this.state.underlyingTokenMint,
                optionTokenMint: this.state.optionTokenMint,
                flexState: flex_sdk_1.Flex.stateAddress,
                flexVaultAuthority: flex_sdk_1.Flex.vaultAuthorityAddress,
                auctionAccount,
                auctionVault,
                systemProgram: web3_js_1.SystemProgram.programId,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                rent: web3_js_1.SYSVAR_RENT_PUBKEY,
                zetaFlexProgram: this.zetaFlexProgram.programId,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async completeAuctionIx(admin) {
        await flex_sdk_1.Flex.updateState();
        const auctionAccounts = flex_sdk_1.Flex.getLiveAuctionsByCreator(this.state.vaultAuthority);
        if (auctionAccounts.length > 1) {
            throw new Error("Cannot be have more than 1");
        }
        else if (auctionAccounts.length === 0) {
            throw new Error("Cannot have empty auction accounts");
        }
        auctionAccounts[0].bids.sort((bidA, bidB) => {
            return bidB.amount - bidA.amount;
        });
        const bid = auctionAccounts[0].bids[0];
        const auctionVault = auctionAccounts[0].auctionVault;
        const type = this.identityContext.getType();
        return this.program.instruction.completeAuction(new anchor.BN(bid.amount), {
            accounts: {
                admin: this.state.admin,
                state: this.state.key,
                vaultAuthority: this.state.vaultAuthority,
                bidTokenVault: type === "structured" ?
                    this.state.quoteTokenVault
                    : this.state.underlyingTokenVault,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                zetaFlexProgram: this.zetaFlexProgram.programId,
                flexState: flex_sdk_1.Flex.stateAddress,
                flexVaultAuthority: flex_sdk_1.Flex.vaultAuthorityAddress,
                auctionAccount: auctionAccounts[0].address,
                auctionVault,
                bidder: bid.bidder,
                bidAccount: bid.address,
                bidVault: bid.bidVault,
                bidderAuctionTokenAccount: bid.bidderAuctionTokenAccount,
            },
            signers: admin ? [admin] : undefined,
        });
    }
    async cancelAuctionIx(admin) {
        await flex_sdk_1.Flex.updateState();
        const auctionAccounts = flex_sdk_1.Flex.getAuctionsByCreator(this.state.vaultAuthority);
        if (auctionAccounts.length === 0) {
            throw new Error("Cannot have empty auction accounts");
        }
        auctionAccounts.sort((a, b) => {
            return b.bidEnd - a.bidEnd;
        });
        const auctionVault = auctionAccounts[0].auctionVault;
        const type = this.identityContext.getType();
        return this.program.instruction.cancelAuction({
            accounts: {
                admin: this.state.admin,
                state: this.state.key,
                vaultAuthority: this.state.vaultAuthority,
                bidTokenVault: type === "structured" ?
                    this.state.quoteTokenVault
                    : this.state.underlyingTokenVault,
                optionTokenMint: this.state.optionTokenMint,
                optionTokenVault: this.state.optionTokenVault,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
                zetaFlexProgram: this.zetaFlexProgram.programId,
                flexState: flex_sdk_1.Flex.stateAddress,
                flexVaultAuthority: flex_sdk_1.Flex.vaultAuthorityAddress,
                auctionAccount: auctionAccounts[0].address,
                auctionVault,
            },
            signers: admin ? [admin] : undefined
        });
    }
    async setExpireOverrideIx(overridePrice, admin) {
        await this.refreshState();
        const flexUnderlying = this.identityContext.getType() === "structured" ?
            flex_sdk_1.Flex.getUnderlying(this.state.underlyingTokenMint).address
            : flex_sdk_1.Flex.getUnderlying(this.state.quoteTokenMint).address;
        const [vault] = await flex_sdk_1.flexUtils.getVaultAddress(this.zetaFlexProgram.programId, this.state.optionAccount);
        return this.program.instruction.setExpireOverride(new anchor.BN(overridePrice), {
            accounts: {
                state: this.state.key,
                underlyingTokenMint: this.state.underlyingTokenMint,
                optionTokenMint: this.state.optionTokenMint,
                vaultAuthority: this.state.vaultAuthority,
                optionAccount: this.state.optionAccount,
                flexState: flex_sdk_1.Flex.stateAddress,
                flexUnderlying,
                flexVault: vault,
                zetaFlexProgram: this.zetaFlexProgram.programId,
                admin: this.state.admin,
            },
            signers: admin ? [admin] : undefined
        });
    }
    ;
    async burnOptionsIx(admin) {
        await this.refreshState();
        await flex_sdk_1.Flex.updateState();
        let optionAccount = this.state.optionAccount;
        let [vault] = await flex_sdk_1.flexUtils.getVaultAddress(this.zetaFlexProgram.programId, optionAccount);
        let [optionMint] = await flex_sdk_1.flexUtils.getOptionMintAddress(this.zetaFlexProgram.programId, optionAccount);
        let [userOptionTokenAccount] = await flex_sdk_1.flexUtils.getUserOptionMintTokenAccountAddress(this.zetaFlexProgram.programId, optionMint, this.state.vaultAuthority);
        return this.program.instruction.burnOptions({
            accounts: {
                admin: this.state.admin,
                state: this.state.key,
                vaultAuthority: this.state.vaultAuthority,
                underlyingTokenMint: this.state.underlyingTokenMint,
                underlyingTokenVault: this.state.underlyingTokenVault,
                optionTokenVault: userOptionTokenAccount,
                flexState: flex_sdk_1.Flex.stateAddress,
                flexVault: vault,
                flexVaultAuthority: flex_sdk_1.Flex.vaultAuthorityAddress,
                mintAuthority: flex_sdk_1.Flex.mintAuthorityAddress,
                optionAccount,
                optionTokenMint: optionMint,
                zetaFlexProgram: flex_sdk_1.Flex.programId,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID
            },
            signers: admin ? [admin] : undefined
        });
    }
    ;
}
exports.StructuredSdk = StructuredSdk;
const objectMap = (obj, fn) => Object.fromEntries(Object.entries(obj).map(([k, v], i) => [k, fn(v, k, i)]));
//  Converts all keys in object to string
const convertPublicKeyObject = (obj) => {
    return objectMap(obj, (v) => {
        if (v) {
            return v.toString();
        }
        else {
            return undefined;
        }
    });
};
exports.convertPublicKeyObject = convertPublicKeyObject;
